import WebOS from './webos';
import Browser from './browser';
import Tizen from './tizen';
import Hisense from './hisense';
import VEWD from './vewd';

const platforms = {
  browser: Browser,
  tizen: Tizen,
  webos: WebOS,
  hisense: Hisense,
  vewd: VEWD,
};

const DEFAULT_PLATFORM = 'browser';
const ENV_PLATFORM = process.env.REACT_APP_PLATFORM;

const Platform = platforms[ENV_PLATFORM || DEFAULT_PLATFORM];

export default new Platform();
